export default __webpack_public_path__ + "static/media/ECG.c6d605f9.png";